import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useStore } from "../../stores/store";
import { observer } from "mobx-react-lite";
import { SyntheticEvent, useEffect } from "react";
import { NewPrompt } from "../../models/newPrompt";

import AdminNav from "./adminNav";

export default observer(function AddPrompt(){
    const {commonStore, userStore, adminStore} = useStore();
    const{adminPrompts} = adminStore;

    useEffect(() => {
        if(commonStore.token){
            userStore.getUser().finally(() => commonStore.setAppLoaded());
        } else{
            commonStore.setAppLoaded()
        }

        adminStore.getAdminPrompts();
    }, [commonStore, userStore, adminStore])
    
   if(!commonStore.appLoaded) return <Container><Row> <h1>Loading...</h1></Row></Container>

   const handleSubmit = async (event: SyntheticEvent) => {
            try
            {
                event.preventDefault();
            
                const target = event.target as typeof event.target & {
                    newPrompt: { value: string},
                }
                
                var newPrompt = {} as NewPrompt;
                newPrompt.promptText = target.newPrompt.value;
                
                
                await adminStore.addNewAdminPrompt(newPrompt);
                
            }catch(error: any){
            
            }
    }

    function handleDelete(id: number){  
        adminStore.deleteAdminPrompt(id);
        adminStore.adminPrompts = adminStore.prompts.filter(p => p.id != id);
    }

    return (
        <>
            {userStore.isLoggedIn ? (

                    <Container>
                        <Row className='mb-3'>
                            <AdminNav />
                        </Row>
                        <Row>
                            <Col lg={12}><h1>Add A New Prompt</h1></Col>
                        </Row>
                        <Row className="mt-4">
                            <Col lg={4}>
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group>
                                        <Form.Control name='newPrompt' className='mb-4' placeholder="Enter new prompt here" type='text' />
                                    </Form.Group>
                                    <Form.Group>
                                        <Button type='submit' variant='success'>Submit</Button>
                                    </Form.Group>
                                </Form>
                            </Col>
                        </Row>
                        <Row className='mt-3'>
                            <Col lg={12}>
                                <h3>Admin prompts</h3>
                            </Col>
                        </Row>
                        <Row className='mt-3'>
                            <Col lg={2}><h5>Prompt Id</h5></Col>
                            <Col lg={4}><h5>Prompt text</h5></Col>
                            <Col lg={2}><h5>Admin</h5></Col>
                            <Col lg={2}><h5>Visible</h5></Col>
                            <Col lg={2}><h5></h5></Col>
                        </Row>
                            {adminPrompts && adminPrompts.map(p => (
                                     <Row className='mt-3 mb-3'>
                                        <Col lg={2}><span id='promptId'>{p.id}</span></Col>
                                        <Col lg={4}><span>{p.promptText}</span></Col>
                                        <Col lg={2}><span>{p.isVisible.toString()}</span></Col>
                                        <Col lg={2}><Button onClick={() => handleDelete(p.id)} variant='danger'>Delete</Button></Col>
                                     </Row>
                                ))}
                    </Container>) :
            (
                <Container><h1>Not logged in</h1></Container>
            )}
        </>
    )
})